import React from 'react'
import styles from './SimpleForm.module.css'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { CustomFieldsFormColumn } from 'components/CustomFields/CustomFieldsColumn/CustomFieldsFormColumn'
import { mapChildrenWithProps } from 'utils/utils'

export function FormColumn ({ section, disabled, visible = true, className, children }) {
  const { t } = useTranslation()
  if (!visible) return null

  return (
    <div className={classNames(styles.container, className)}>
      {section && <h2>{t(section.label)}</h2>}
      {children && mapChildrenWithProps(children, { disabled })}
      <CustomFieldsFormColumn section={section} disabled={disabled}/>
    </div>
  )
}
